import {BaseAttribute, BaseAttributeOptions} from './BaseAttribute';

export type LocationAttributeOptions = BaseAttributeOptions;

// Attribute for geo / map location fields
export class LocationAttribute extends BaseAttribute {
  constructor(options: LocationAttributeOptions = {}) {
    super(options);
  }

  // Input type that is used if attribute is used in edit mode
  get inputType(): string {
    return 'location';
  }
}
